import { InputPhoneNumber } from "@/components/Input/Phone/InputPhoneNumber";
import type { PhoneValue } from "@/components/Input/Phone/state.machine";
import { useFormattedPhoneNumber } from "@/hooks/useFormattedPhoneNumber";

import {
  CFormItemBase,
  type CFormItemProps,
  buildCFormItem,
} from "../CFormItem";

/**
 * 日本の国番号（デフォルト値として使用）
 */
export const JAPAN_DIAL_CODE = "81";

type Props = CFormItemProps & {
  value: PhoneValue;
  onChange: (value: PhoneValue) => void;
};

/**
 * Card-based Form / PhoneItem
 *
 * 電話番号入力用のCFormアイテム。
 * InputPhoneNumber（国番号ドロップダウン付き）を使用します。
 */
export const CFormPhoneItem = buildCFormItem((props: Props) => {
  const value: PhoneValue = props.value ?? {
    dialCode: JAPAN_DIAL_CODE,
    phoneNumber: "",
  };

  // フォーマット済み表示用
  const { formattedFull } = useFormattedPhoneNumber(value);

  return (
    <CFormItemBase
      {...props}
      readComponent={formattedFull}
      writeComponent={
        <InputPhoneNumber
          value={value}
          onChange={props.onChange}
          required={props.required}
        />
      }
    />
  );
});
